// extracted by mini-css-extract-plugin
module.exports = {"root":"SnackbarContent_root__1Xvbd","message":"SnackbarContent_message__Rdt1c","icon":"SnackbarContent_icon__2CvOb","action":"SnackbarContent_action__1NqWM"};